import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative w-full bg-background-100 pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-[380px] h-[380px] rounded-full bg-primary-200/40 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[320px] h-[320px] rounded-full bg-secondary-200/40 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="animate-rise">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-xs md:text-sm text-foreground-700 font-label">
            <i className="ri-book-marked-line text-primary-600"></i>
            写给怀念过去的人
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            在长日光阴里，
            <br className="hidden md:block" />
            重新拾起那些<span className="text-accent-600">被时间冲淡</span>的温暖瞬间
          </h1>

          <p className="mt-5 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
            这里收录长日光阴视角下的情感故事与岁月往事。从一件旧物、一段告别，到生活里那些说不出口的碎碎念，
            我们把它们慢慢写下来，留给同样喜欢听故事的你。愿你在这里读到共鸣，也读到一点安慰。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#stories"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              开始读故事
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-quill-pen-line"></i>
              写下我的回忆
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5">
            {heroStats.map((stat) => (
              <div key={stat.label} className="border-l-2 border-primary-300 pl-3">
                <dt className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs text-foreground-500">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative animate-rise">
          <div className="w-full h-[320px] sm:h-[420px] lg:h-[540px] rounded-lg overflow-hidden border border-background-300">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20nostalgic%20stylized%20illustration%20of%20a%20quiet%20sunlit%20room%20in%20late%20afternoon%2C%20sheer%20lace%20curtains%20by%20a%20tall%20window%2C%20an%20old%20wooden%20writing%20desk%20with%20a%20fountain%20pen%20and%20stacked%20letters%2C%20golden%20dust%20motes%20floating%20in%20the%20air%2C%20soft%20sepia%20and%20honey%20amber%20tones%2C%20painterly%20editorial%20artwork%20with%20gentle%20grain%2C%20cozy%20reflective%20memoir%20mood&width=800&height=1000&seq=hero-desk-01&orientation=portrait"
              alt="午后阳光下的旧书桌，窗边放着信纸与钢笔，长日光阴回忆录的场景"
              title="长日光阴 · 旧时光里的书桌与回忆"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 -left-3 md:left-6 bg-background-50 border border-background-200 rounded-lg px-4 py-3 max-w-[220px] shadow-none">
            <p className="font-heading text-sm text-foreground-800 leading-relaxed">
              「记忆不会消失，它只是在等一个安静的下午。」
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}